module.exports = __webpack_public_path__ + "img/621.3d05b508.png";